import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBM: CultureInfo = {
  name: 'en-BM',
  displayName: 'English (Bermuda)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BM',
  parent: CultureInfoEn
};
